import * as r from "react";
import o from "../lib/IconBase.es.js";
import c from "../defs/SubtractSquare.es.js";
const t = r.forwardRef((a, e) => /* @__PURE__ */ r.createElement(o, { ref: e, ...a, weights: c }));
t.displayName = "SubtractSquareIcon";
const n = t;
export {
  n as SubtractSquare,
  t as SubtractSquareIcon
};
